import { useDispatch } from "react-redux";
import {
  setBailiffJobDetail,
  setBailiffJobOpenPayment,
  setBailiffJobSelected,
} from "store/bailiff/bailiff/job/bailiff_job.action";
import { setOrderBailiffAll } from "store/bailiff/payment/order/order_bailiff.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useJobPayment = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleSelect = (data) => {
    dispatch(setBailiffJobSelected(data));
    dispatch(setBailiffJobOpenPayment(true));
  };

  const handleClose = () => {
    dispatch(setBailiffJobSelected(null));
    dispatch(setBailiffJobOpenPayment(false));
    dispatch(setBailiffJobDetail(null));
    dispatch(setOrderBailiffAll(null));
  };

  const handlePayment = () => {
    handleClose();
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleSelect, handleClose, handlePayment };
};
